var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"target"},[(_vm.isVisible)?_c('img',{staticClass:"rounded",style:({width:_vm.width, height:_vm.height}),attrs:{"src":_vm.src,"alt":_vm.alt}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }